import { Layout as FacetPlanProposalNextUpAccountDetailItemLayout } from './FacetPlanProposalNextUpAccountDetailItem';
import { Layout as FacetPlanProposalNextUpDetailItemNonAUMLayout } from './FacetPlanProposalNextUpDetailItemNonAUM';
import { Layout as DefaultLayout } from './Default';

export const DETAIL_LAYOUTS = {
  FacetPlanProposalNextUpAccountDetailItem: 'FacetPlanProposalNextUpAccountDetailItem',
  FacetPlanProposalNextUpDetailItemNonAUM: 'FacetPlanProposalNextUpDetailItemNonAUM',
  FacetPlanReadonlyNextUpDetailItem: 'FacetPlanReadonlyNextUpDetailItem',
};

export default function getDetailLayout(headResourceType) {
  switch (headResourceType) {
    case DETAIL_LAYOUTS.FacetPlanProposalNextUpAccountDetailItem:
      return {
        Layout: FacetPlanProposalNextUpAccountDetailItemLayout,
      };
    case DETAIL_LAYOUTS.FacetPlanProposalNextUpDetailItemNonAUM:
      return {
        Layout: FacetPlanProposalNextUpDetailItemNonAUMLayout,
      };
    case DETAIL_LAYOUTS.FacetPlanReadonlyNextUpDetailItem:
      return {
        Layout: FacetPlanProposalNextUpAccountDetailItemLayout,
      };
    default:
      return {
        Layout: DefaultLayout,
      };
  }
}
